import { DriverService } from './../../../services/driver.service';
import { element } from 'protractor';
import { AuthService } from 'src/app/services/auth.service';
import { ViewBookingModel } from 'src/app/models/Booking/ViewBookingModel';
import { Vehicle } from './../../../models/Vehicle';
import { CrossBorderModel } from './../../../models/Booking/CrossBorderModel';
import { BehaviorSubject } from 'rxjs';


import { SearchService } from './../../../services/search.service';
import { BookingService } from './../../../services/booking.service';
import { Component, OnInit, Input, OnChanges, SimpleChanges, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { faCreditCard, faCar, faMoneyBillWave, faCheck } from '@fortawesome/free-solid-svg-icons';
import { FormGroup, FormArray, FormControl } from '@angular/forms';
import { LstAdditionalServiceReservationCase, LstPolicyReservationCaseModel, LstVehicleReservationCaseNonWorkingHoursChargeModel } from 'src/app/models/VehicleReservationCaseDetailsModel';
import { DiscountScopeEnum, PredefinedAdditionalServiceEnum, PolicyType, AgeRestrictionPolicyTypes, DepositPolicyPaymentTypes, RentalTypeViewEnum, ChargeSummaryMode } from 'src/app/models/enums/BookingEnums';
import { DriverSkillModel } from 'src/app/models/Booking/DriverSkillModel';
import { OneWayRentalModel } from 'src/app/models/Booking/OneWayRentalModel';
import { VehicleReservationCaseManualCharges, VehicleReservationCaseRentalPeriodModel, VehicleReservationCaseResult } from 'src/app/models/Booking/VehicleReservationCaseResult';
import { VehicleReservationCaseDetailsModel } from 'src/app/models/VehicleReservationCaseDetailsModel'


//#endregion Helper Discount class
class FreeService {
  additionalServiceID: number;
  predefinedAdditionalServiceID: number;
  quantity?: number;
  isQuantitative
}
class FreePolicy {
  FreePolicyID: number;
  policyType: number;
  policyDefinitionID: number;
  policyTypeName: string;
  lang: string;

}
//#endregion
@Component({
  selector: 'charge-summary',
  templateUrl: './charge-summary.component.html',
  styleUrls: ['./charge-summary.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ChargeSummaryComponent implements OnInit, OnChanges {
  //@Input() bookingForm: FormGroup;
  @Input() bookingData: any;
  bookingForm: FormGroup;
  //chargeSummary;
  currency;
  lstAdditionalServiceReservationCase: LstAdditionalServiceReservationCase[] = [];
  vehicleReservationCaseRentalPeriodModel: VehicleReservationCaseRentalPeriodModel[];
  customerAge: number;
  ageResrictionPolicyFlag = false;
  ageRestrectionCharge: number = 0;

  formControlPrefix = 's_';
  formControlTogglePostfix = '_toggle';
  formControlTotalPostfix = '_total';

  titleNonworking: boolean = true;

  //#region discount variables
  //rentalPriceAfterDiscount: number;
  //subTotalAfterDiscount: number;
  //#endregion

  //types of the page , (for the add? or in the update,etc..)
  @Input() mode: ChargeSummaryMode = ChargeSummaryMode.Add;

  //ViewBooking with List of additional services in case of update
  @Input() viewBookingData: any;
  viewBooking: ViewBookingModel;
  @Input() vehicleReservationCaseResult: VehicleReservationCaseResult;
  vehicleReservationCaseDetailsModel: VehicleReservationCaseDetailsModel;
  lstPolicyReservationCaseModel: LstPolicyReservationCaseModel[];

  //#region  Discount Variables
  freePolicies: FreePolicy[] = [];
  freeServices: FreeService[] = [];
  //#endregion

  manualCharges: VehicleReservationCaseManualCharges[];

  @Input() updateMode: boolean;
  lstVehicleReservationCaseNonWorkingHoursChargeModel: LstVehicleReservationCaseNonWorkingHoursChargeModel[];
  deposiePolicy: LstPolicyReservationCaseModel;
  calculateTotalResult: number = 0;
  skillRateSum: any;

  constructor(
    private authService: AuthService,
    private cd: ChangeDetectorRef,
    private bookingService: BookingService,
    private driverService: DriverService,
    private currencyService: SearchService) {
    this.currency = currencyService.getCurrency();

  }

  public get policyType(): typeof PolicyType {
    return PolicyType;
  }
  get predefinedAdditionalServiceEnum(): typeof PredefinedAdditionalServiceEnum {
    return PredefinedAdditionalServiceEnum;
  }

  get discountScope(): typeof DiscountScopeEnum {
    return DiscountScopeEnum;
  }

  get depositPolicyPaymentTypes() {
    return DepositPolicyPaymentTypes;
  }

  faCreditCard = faCreditCard;
  faCar = faCar;
  faMoneyBillWave = faMoneyBillWave;
  faCheck = faCheck;
  chargeSummary: any;
  //Tax variables
  taxableAmount: number;
  totalTax: number;
  taxPercent: number = 0;
  taxData: any;
  vehicle: Vehicle;
  subTotal: number;
  itemprice;
  //Duration In Days
  durationInDays: number = 0;
  ngOnInit() {

    this.chargeSummary = {
      durationUnit: "D"
    }

    this.bookingService
      .vehicle
      .subscribe(res => {
        if (res == null) {
          let _cahchedVehicle = this.bookingService.getCachedVehicle();
          if (_cahchedVehicle != null) {
            this.vehicle = _cahchedVehicle;
          }
          else {
            //Todo:
            //Redirect the User
          }
        }
        else {
          this.vehicle = res
        }

      });

    this.authService.loggedInCustomer.subscribe(res => {
      if (res != null) {
        //Get Customer Age
        this.customerAge = res.age;
      }


      if (this.mode == ChargeSummaryMode.Add) {
        this.bookingService.vehicleReservationCaseDetailsModel.subscribe(res => {

          if (res != null) {

            this.lstAdditionalServiceReservationCase = res.lstAdditionalServiceReservationCase;




            this.lstPolicyReservationCaseModel = res.lstPolicyReservationCaseModel;
            this.lstVehicleReservationCaseNonWorkingHoursChargeModel = res.lstVehicleReservationCaseNonWorkingHoursChargeModel;



            this.durationInDays = res.durationInDays;



            this.taxPercent = res.taxePercanteage / 100;
            this.vehicleReservationCaseRentalPeriodModel = res.vehicleReservationCaseRentalPeriodModel;
            this.vehicleReservationCaseDetailsModel = res;



            this.freePolicies = this.getFreePolicies(this.vehicleReservationCaseDetailsModel);
            this.freeServices = this.getFreeServices(this.vehicleReservationCaseDetailsModel);



            if (this.lstPolicyReservationCaseModel != null) {
              this.deposiePolicy = this.lstPolicyReservationCaseModel.filter(a => a.policyDefinitionId == PolicyType.DepositPolicy)[0];
            }

            this.calculateAgeRestrictionPolicy(this.lstPolicyReservationCaseModel);
            this.cd.markForCheck();
          }

        });
      }
      else {


        if (this.viewBookingData != null) {
          this.viewBookingData.subscribe(res => {

            if (res != null) {
              this.viewBooking = res;
              this.lstAdditionalServiceReservationCase = this.viewBooking.lstAdditionalServiceReservationCase;

              this.lstVehicleReservationCaseNonWorkingHoursChargeModel = this.viewBooking.lstVehicleReservationCaseNonWorkingHoursChargeModel;
              //For Now
              //Todo:
              this.manualCharges = this.vehicleReservationCaseResult.vehicleReservationCaseManualCharges;
              this.durationInDays = this.viewBooking.durationInDays
              this.taxPercent = this.viewBooking.taxPercentage / 100;
              this.vehicleReservationCaseRentalPeriodModel = this.viewBooking.vehicleReservationCaseRentalPeriodModel;
              this.vehicleReservationCaseDetailsModel = this.viewBooking.vehicleReservationDetailsModel;
              //Todo: Make one code for both mode
              this.freePolicies = this.getFreePolicies(this.viewBooking.vehicleReservationDetailsModel);
              this.freeServices = this.getFreeServices(this.viewBooking.vehicleReservationDetailsModel);

              this.lstPolicyReservationCaseModel = this.viewBooking.lstPolicyReservationCaseModel;
              if (this.lstPolicyReservationCaseModel != null) {
                this.deposiePolicy = this.lstPolicyReservationCaseModel.filter(a => a.policyDefinitionId == PolicyType.DepositPolicy)[0];
              }


              this.calculateAgeRestrictionPolicy(this.lstPolicyReservationCaseModel);
              this.cd.markForCheck();

            }
          })
        }


      }

    })

    this.driverService.newDriverAge.subscribe(res => {
      if (res != null) {
        this.customerAge = this.driverService.calculateAgeFromBirthdate(res);
        this.calculateAgeRestrictionPolicy(this.lstPolicyReservationCaseModel);
        this.cd.markForCheck();
      }
    })





    this.bookingData.subscribe(data => {
      this.bookingForm = data;

      this.cd.markForCheck();
    });
    this.taxData = new BehaviorSubject({
      totalTax: this.totalTax,
      taxableAmount: this.taxableAmount
    });

    this.taxData
      .subscribe(res => {
        this.totalTax = res.totalTax;
        this.taxableAmount = res.taxableAmount;
        this.cd.markForCheck();
      });



  }
  public get campaignsReservationCaseModel() {
    return this.vehicleReservationCaseDetailsModel != null ? this.vehicleReservationCaseDetailsModel.campaignsReservationCaseModel : null;
  }
  public get membershipModel() {

    return this.vehicleReservationCaseDetailsModel != null ? this.vehicleReservationCaseDetailsModel.membershipModel : null;
  }
  get totalRentalPrice() {
    if (this.vehicleReservationCaseRentalPeriodModel != null) {
      let sum = 0;
      this.vehicleReservationCaseRentalPeriodModel.forEach(i => {

        sum += i.sumDurationRentalPrice;
      })
      return sum;
    }
    else {
      return 0;
    }
  }

  get isNoDeposiePolicy(): boolean {
    if (this.freePolicies != null) {
      let depositePolicy = this.freePolicies.filter(a => a.policyDefinitionID == PolicyType.DepositPolicy)[0];
      if (depositePolicy != null) {
        return true;
      }
    }
    return false;
  }
  // convenience getters for easy access to form fields
  get f() { return this.bookingForm.controls; }

  get isHavingChargedNonWorkingHours() {

    if (this.lstVehicleReservationCaseNonWorkingHoursChargeModel != null && this.lstVehicleReservationCaseNonWorkingHoursChargeModel.length > 0 && this.lstVehicleReservationCaseNonWorkingHoursChargeModel.filter(a => (a.isActive == null || a.isActive) && a.unitPrice > 0)[0] != null) {
      return true;
    }
    return false;
  }
  //Get Borders
  getBorders(additionalServiceID) {

    let borders = [];
    let bordersForm =
      this.bookingForm.controls[this.formControlPrefix + additionalServiceID + '_Borders'] as FormArray;

    let _freeService = this.freeServices.filter(o => o.additionalServiceID == additionalServiceID)[0];


    bordersForm.controls.forEach(fg => {
      let formGroup = fg as FormGroup;
      let border = formGroup.controls['BorderObj'].value as CrossBorderModel;
      if (_freeService != null) {
        border.charge = 0;
      }
      borders.push(border)
    });
    return borders;
  }

  //Check if the additional Service is free or not based on Campaign/Membership
  isFreeService(predefinedAdditionalServiceID) {

    let _freeService = this.freeServices.filter(o => o.predefinedAdditionalServiceID == predefinedAdditionalServiceID)[0];
    return _freeService != null;
  }

  test() {


  }
  ngOnChanges(changes: SimpleChanges) {

  }
  calculateAdditionalDriverPrice() {
    return 'From Method'
  }

  calculatePriceMain(additionalService: LstAdditionalServiceReservationCase) {

    switch (additionalService.predefinedAdditionalServiceID) {
      case PredefinedAdditionalServiceEnum.AdditionalDrivers:
        return this.calculatePrice(additionalService, true);
    }
  }

  calculatePrice(additionalService: LstAdditionalServiceReservationCase, isQuantable, quantity?) {
    let total = 0;
    if (additionalService.isPerDay) {
      total = additionalService.unitPrice * this.durationInDays;
    }
    else {
      total = additionalService.unitPrice;
    }

    if (isQuantable) {
      //let quantity=this.bookingForm.controls[this.formControlPrefix+additionalService.additionalServiceID].value;
      total = total * quantity;
    }

    return total;

  }

  calculatePriceDriverSkill(additionalService: LstAdditionalServiceReservationCase, skills: DriverSkillModel[], mode: ChargeSummaryMode) {


    //Incase of viewMode/Update
    // if (this.updateMode != null && this.updateMode) {
    //   return additionalService.unitPrice * this.durationInDays;
    // }

    //here we will always multiply by duration (* DurationInDays)
    //(Sum of selected skills rate + Driver Rate) * DurationInDays

    if (mode == ChargeSummaryMode.Add) {


    }
    else {

      //return additionalService.driverRate * this.durationInDays;

    }
    let skillRateSum = 0;
    skills.forEach(element => {
      skillRateSum += element.driverSkillRate;
    });
    this.skillRateSum = additionalService.driverRate + skillRateSum;
    return (additionalService.driverRate + skillRateSum) * this.durationInDays;
  }

  calculatePriceOneWayRental(additionalService: LstAdditionalServiceReservationCase, skills: OneWayRentalModel) {

    //Here there is no duration and no Unit price

    let skillRateSum = 0;
    skillRateSum += skills.charge;
    return skillRateSum;
  }
  calculatePriceCrossingBorder(model: CrossBorderModel) {
    let price = 0;
    // if (model.isNewInsurence) {
    //   price = model.charge + model.increase;
    // }
    // else {
    //   price = model.charge;
    // }

    price = model.charge;
    return price;
  }

  calculateTax(price, tax) {
    return price * tax;
  }



  calculateTotal(lstAdditionalServiceReservationCase: LstAdditionalServiceReservationCase[]) {
    //Todo: cache the previeous model and compare if no change do not do anything.
    //Recomened : change the  Detection Strategey to be OnPush but it need to update the input()


    if (lstAdditionalServiceReservationCase == null)
      return

    this.taxableAmount = 0;
    this.totalTax = 0;
    let totalPrice = 0;
    let subTotal = 0;

    //  if(this.bookingForm.dirty){


    lstAdditionalServiceReservationCase.forEach(element => {
      let servicePrice = 0;
      let serviceTax = 0;
      let amountTaxed = 0;

      let control = this.bookingForm.controls[this.formControlPrefix + element.additionalServiceID];
      let controlToggle = this.bookingForm.controls[this.formControlPrefix + element.additionalServiceID + this.formControlTogglePostfix];
      let controlTotal = this.bookingForm.controls[this.formControlPrefix + element.additionalServiceID + this.formControlTotalPostfix];
      let _freeService = this.freeServices.filter(o => o.additionalServiceID == element.additionalServiceID || o.predefinedAdditionalServiceID == element.predefinedAdditionalServiceID)[0];

      let freeQuantity = 0;
      if (controlToggle != null && controlToggle.value) {

        switch (element.predefinedAdditionalServiceID) {
          case PredefinedAdditionalServiceEnum.AdditionalDrivers:

            //Check if the current service exist in the free services list

            //Check the quantity because the Current Service is Quantitative
            if (_freeService != null && _freeService.quantity != null) {
              freeQuantity = _freeService.quantity;
            }
            //If the total of quaity is more than free , then start calculate the price
            if (control.value > freeQuantity) {
              //We will start calculating from the first quantity after the free quantity number
              servicePrice = this.calculatePrice(element, true, (control.value - freeQuantity));
            }

            controlTotal.setValue(servicePrice);
            if (element.isTaxable) {
              //Calculate Tax
              this.taxableAmount += servicePrice;
              this.totalTax += this.calculateTax(servicePrice, this.taxPercent);

            }
            totalPrice += servicePrice;
            break;
          case PredefinedAdditionalServiceEnum.Drivers:


            if (control.value != null && Object.keys(control.value).length > 0) {

              let driverModelList = control.value as DriverSkillModel[]; //Todo: multiple select

              //If its not Quantitative then calculate the service price if its not exist in the FreeService list
              if (_freeService == null) {
                servicePrice = this.calculatePriceDriverSkill(element, driverModelList, this.mode);
              }

              controlTotal.setValue(servicePrice);
              if (element.isTaxable) {
                this.taxableAmount += servicePrice;
                this.totalTax += this.calculateTax(servicePrice, this.taxPercent);

              }
              totalPrice += servicePrice;
            }
            else {
              let driverModelList = []; //Todo: multiple select

              //If its not Quantitative then calculate the service price if its not exist in the FreeService list
              if (_freeService == null) {
                servicePrice = this.calculatePriceDriverSkill(element, driverModelList, this.mode);
              }

              controlTotal.setValue(servicePrice);
              if (element.isTaxable) {
                this.taxableAmount += servicePrice;
                this.totalTax += this.calculateTax(servicePrice, this.taxPercent);

              }
              totalPrice += servicePrice;
            }

            break;
          case PredefinedAdditionalServiceEnum.OneWayRentalService:

            //Todo: how to compute tax for this
            if (control.value != null && Object.keys(control.value).length > 0) {
              let oneWayRentalModel = control.value as OneWayRentalModel;   //If its not Quantitative then calculate the service price if its not exist in the FreeService list
              let oneWayRentalMandotoryWithoutValue = false;
              if (Object.keys(control.value).length == 1 && Object.keys(control.value).includes("value") && oneWayRentalModel["value"] == null) {
                oneWayRentalMandotoryWithoutValue = true;
              }
              if (_freeService == null && !oneWayRentalMandotoryWithoutValue) {
                servicePrice = this.calculatePriceOneWayRental(element, oneWayRentalModel);
              }

              controlTotal.setValue(servicePrice);
              if (element.isTaxable) {
                this.taxableAmount += servicePrice;
                this.totalTax += this.calculateTax(servicePrice, this.taxPercent);

              }
              totalPrice += servicePrice;
            }
            break
          case PredefinedAdditionalServiceEnum.RentalDelivery:

            let crossingBorderForm = control.value as FormGroup;

            //If its not Quantitative then calculate the service price if its not exist in the FreeService list
            if (_freeService == null) {
              //Here we have two toggle One for pickup and one for return
              if (crossingBorderForm['PickUpToggle']) {
                //update the price and total price
                servicePrice += this.calculateRentalDeliveryPrice(element, RentalTypeViewEnum.Pickup);
                // servicePrice += this.calculatePrice(element, false);
              }
              if (crossingBorderForm['ReturnToggle']) {
                servicePrice += this.calculateRentalDeliveryPrice(element, RentalTypeViewEnum.Return);
                //servicePrice += this.calculatePrice(element, false);
              }
            }

            controlTotal.setValue(servicePrice);
            if (element.isTaxable) {
              //Calculate Tax
              this.taxableAmount += servicePrice;
              this.totalTax += this.calculateTax(servicePrice, this.taxPercent);

            }
            totalPrice += servicePrice;
            break
          case PredefinedAdditionalServiceEnum.CrossingBoarders:

            let bordersForm = this.bookingForm.controls['s_' + element.additionalServiceID + '_Borders'] as FormArray;
            //If its not Quantitative then calculate the service price if its not exist in the FreeService list
            if (_freeService == null) {
              bordersForm.controls.forEach(fg => {

                let formGroup = fg as FormGroup;
                let border = formGroup.controls['BorderObj'].value as CrossBorderModel;
                servicePrice += this.calculatePriceCrossingBorder(border);
              });
            }
            controlTotal.setValue(servicePrice);
            if (element.isTaxable) {
              //Calculate Tax
              this.taxableAmount += servicePrice;
              this.totalTax += this.calculateTax(servicePrice, this.taxPercent);
            }
            totalPrice += servicePrice;
            break
          default:


            if (element.isPhysicalAddon) {

              if (_freeService != null && _freeService.quantity != null) {
                freeQuantity = _freeService.quantity;
              }
              //If the total of quaity is more than free , then start calculate the price
              if (control.value > freeQuantity) {
                //We will start calculating from the first quantity after the free quantity number
                servicePrice = this.calculatePrice(element, true, (control.value - freeQuantity));
              }

            }
            else {
              //If its not Quantitative then calculate the service price if its not exist in the FreeService list
              if (_freeService == null) {
                servicePrice = this.calculatePrice(element, false);
              }
            }

            //servicePrice = element.isPhysicalAddon ? this.calculatePrice(element, true, control.value) : this.calculatePrice(element, false);
            controlTotal.setValue(servicePrice);
            if (element.isTaxable) {
              this.taxableAmount += servicePrice;
              this.totalTax += this.calculateTax(servicePrice, this.taxPercent);
            }
            totalPrice += servicePrice;
            break
        }
      }

    });


    if (this.ageResrictionPolicyFlag) {
      subTotal += this.ageRestrectionCharge;
      this.taxableAmount += this.ageRestrectionCharge;
    }


    //Todo: add policy price to subtotal
    //Now the subtotal have the sum of additinal services price
    subTotal += totalPrice;
    this.subTotal = subTotal;



    /*The List outsideworking hour pickup/return  Comes after calculate the disscount*/
    if (this.lstVehicleReservationCaseNonWorkingHoursChargeModel != null) {

      /* //IF there is one way rental enabled then there is multiple drop off delivery charge
      if(this.lstVehicleReservationCaseNonWorkingHoursChargeModel.filter(a =>a.isDropOffAndOneWayRental)[0]!=null){
        let oneWayRentalNonWorking=this.lstVehicleReservationCaseNonWorkingHoursChargeModel.filter(a =>a.isDropOffAndOneWayRental)[0];
        this.subTotal += oneWayRentalNonWorking.unitPrice;
        if (oneWayRentalNonWorking.isTaxable) {
          this.taxableAmount += oneWayRentalNonWorking.unitPrice;
        }

        //Todo: change nonWorkingHoursChargeTypeID to enum
        let pickUpNonWorking=this.lstVehicleReservationCaseNonWorkingHoursChargeModel.filter(a =>a.nonWorkingHoursChargeTypeID==1)[0];
        if(pickUpNonWorking!=null){
          this.subTotal += pickUpNonWorking.unitPrice;
          if (pickUpNonWorking.isTaxable) {
            this.taxableAmount += pickUpNonWorking.unitPrice;
          }
        }

      }
      //Else calculate all the list
      else{
        this.lstVehicleReservationCaseNonWorkingHoursChargeModel.forEach(element => {
          if(element.isActive){
            this.subTotal += element.unitPrice;
            if (element.isTaxable) {
              this.taxableAmount += element.unitPrice;
            }
          }

        });
      } */

      this.lstVehicleReservationCaseNonWorkingHoursChargeModel.forEach(element => {
        if (element.isActive == null || element.isActive) {
          this.subTotal += element.unitPrice;
          if (element.isTaxable) {
            this.taxableAmount += element.unitPrice;
          }
        }

      });

      this.lstVehicleReservationCaseNonWorkingHoursChargeModel.forEach(element => {

        if (element.unitPrice != 0) {
          this.titleNonworking = false;
        }
      });


    }

    let totalRentalTimeAfterDiscount;

    if ((this.campaignsReservationCaseModel != null
      &&
      this.campaignsReservationCaseModel.discountScopeID == DiscountScopeEnum.RentalPeriod)
      ||
      (this.membershipModel != null && this.membershipModel.discountScopeID == DiscountScopeEnum.RentalPeriod)
    ) {
      totalRentalTimeAfterDiscount = this.calculateDiscountRentalPeriod();
      this.subTotal += totalRentalTimeAfterDiscount;
      this.taxableAmount += totalRentalTimeAfterDiscount;
    }
    else {
      this.subTotal += this.totalRentalPrice;
      this.taxableAmount += this.totalRentalPrice;
    }


    if ((this.campaignsReservationCaseModel != null
      &&
      this.campaignsReservationCaseModel.discountScopeID == DiscountScopeEnum.TotalCharges)
      ||
      (this.membershipModel != null && this.membershipModel.discountScopeID == DiscountScopeEnum.TotalCharges)
    ) {
      let subTotalAfterDiscount = this.calculateDiscountTotalCharges();
      this.subTotal = subTotalAfterDiscount;
      this.taxableAmount = this.calculateDiscountTax();
    }

    //The manual Charge Comes after calculate the disscount
    /*Add manual charges for the total discounted price and for tax if it's taxable */
    if (this.manualCharges != null) {

      this.manualCharges.forEach(element => {
        this.subTotal += element.amount;
        if (element.isTaxable) {
          this.taxableAmount += element.amount;
        }
      });
    }



    this.totalTax = this.taxableAmount * this.taxPercent;


    //Format the tax to be 2 digit .00
    this.totalTax = Number((Math.round(this.totalTax * 100) / 100).toFixed(2));


    //totalPrice += this.totalTax;
    //Add vehicle price for the total price
    //totalPrice += this.vehicle.vehiclePrice;
    //subTotal += this.totalRentalPrice;
    //this.subTotal = subTotal;
    //setTimeout(() => this.totalTax = this.totalTax, 0); //This due to angular not detect the change of the variable directly
    // this.bookingForm.markAsPristine();
    //}

    this.changeForm(this.bookingForm);
    this.calculateTotalResult = this.subTotal + this.totalTax;
    return this.subTotal + this.totalTax;
  }
  calculateRentalDeliveryPrice(additionalService: LstAdditionalServiceReservationCase, RentalType: RentalTypeViewEnum) {
    let total = 0;
    let unitPrice = 0;

    if (RentalType == RentalTypeViewEnum.Pickup) {
      unitPrice = additionalService.pickupUnitPrice;
    }
    else if (RentalType == RentalTypeViewEnum.Return) {
      unitPrice = additionalService.returnUnitPrice;
    }

    if (additionalService.isPerDay) {
      total = unitPrice * this.durationInDays;
    }
    else {
      total = unitPrice;
    }


    return total;

  }


  changeForm(model) {
    this.bookingData.next(new FormGroup(model.controls));
  }

  //#region Discount

  calculateDiscountRentalPeriod() {

    let discount = 0;
    let discountPrice = 0;
    if (this.campaignsReservationCaseModel != null) {
      discountPrice += (this.campaignsReservationCaseModel.discount / 100) * this.totalRentalPrice;
    }
    if (this.membershipModel != null) {
      discountPrice += (this.membershipModel.discountValue / 100) * this.totalRentalPrice;
    }
    return this.totalRentalPrice - discountPrice;
  }

  calculateDiscountTotalCharges() {
    let discountPrice = 0;
    if (this.campaignsReservationCaseModel != null) {
      discountPrice += (this.campaignsReservationCaseModel.discount / 100) * this.subTotal;
    }
    if (this.membershipModel != null) {
      discountPrice += (this.membershipModel.discountValue / 100) * this.subTotal;
    }
    return this.subTotal - discountPrice;
  }

  calculateDiscountTax() {
    let discountPrice = 0;
    if (this.campaignsReservationCaseModel != null) {
      discountPrice += (this.campaignsReservationCaseModel.discount / 100) * this.taxableAmount;
    }
    if (this.membershipModel != null) {
      discountPrice += (this.membershipModel.discountValue / 100) * this.taxableAmount;
    }
    return this.taxableAmount - discountPrice;
  }

  calculateDiscount() {

    if ((this.campaignsReservationCaseModel != null
      &&
      this.campaignsReservationCaseModel.discountScopeID == DiscountScopeEnum.RentalPeriod)
      ||
      (this.membershipModel != null && this.membershipModel.discountScopeID == DiscountScopeEnum.RentalPeriod)
    ) {
      this.calculateDiscountRentalPeriod();
    }
    else {
      this.calculateDiscountTotalCharges();
    }
  }

  getFreePolicies(model: VehicleReservationCaseDetailsModel) {
    if (model != null) {
      let freePolices = [];
      if (model.membershipModel != null && model.membershipModel.lstCustomerMembershipFreePolicies != null) {
        model.membershipModel.lstCustomerMembershipFreePolicies.forEach(element => {
          let _freePolicy: FreePolicy = {
            FreePolicyID: element.customerMembershipFreePolicyID,
            policyDefinitionID: element.policyDefinitionID,
            policyType: element.policyType,
            policyTypeName: element.policyTypeName,
            lang: element.lang
          }
          freePolices.push(_freePolicy);
        });
      }
      if (model.campaignsReservationCaseModel != null && model.campaignsReservationCaseModel.campaignFreePolicies != null) {
        model.campaignsReservationCaseModel.campaignFreePolicies.forEach(element => {
          let _freePolicy: FreePolicy = {
            FreePolicyID: element.campaignFreePolicyID,
            policyDefinitionID: element.policyDefinitionID,
            policyType: element.policyType,
            policyTypeName: element.policyTypeName,
            lang: element.lang
          }
          freePolices.push(_freePolicy);
        });

      }
      return freePolices;
    }
    return [];
  }

  getFreeServices(model: VehicleReservationCaseDetailsModel) {


    if (model != null) {
      let freeServices = [];
      if (model.membershipModel != null && model.membershipModel.lstMembershipAdditionalServices != null) {
        model.membershipModel.lstMembershipAdditionalServices.forEach(element => {
          let _freeService: FreeService = {
            additionalServiceID: element.additionalServiceID,
            predefinedAdditionalServiceID: element.predefinedAdditionalServiceID,
            isQuantitative: element.isQuantitative,
            quantity: element.quantity
          }
          freeServices.push(_freeService);
        });
      }
      if (model.campaignsReservationCaseModel != null && model.campaignsReservationCaseModel.campaignAdditionalServices != null) {
        model.campaignsReservationCaseModel.campaignAdditionalServices.forEach(element => {
          let _freeService: FreeService = {
            additionalServiceID: element.additionalServiceID,
            predefinedAdditionalServiceID: element.predefinedAdditionalServiceID,
            isQuantitative: element.isQuantitative,
            quantity: element.quantity
          }
          freeServices.push(_freeService);
        });
      }
      return freeServices;
    }
    return [];
  }

  //#endregion

  calculateAgeRestrictionPolicy(lstPolicyReservationCaseModel: LstPolicyReservationCaseModel[]) {

    let agePolicy = lstPolicyReservationCaseModel.filter(o => o.policyDefinitionId == PolicyType.AgeRestrictionPolicy)[0];



    let anyFLagOn = false;
    if (agePolicy != null) {


      if (this.mode == ChargeSummaryMode.Modify && agePolicy.isApply && !agePolicy.isFree) {
        this.ageRestrectionCharge = agePolicy.unitPrice;
        this.ageResrictionPolicyFlag = true;
      }
      else {

        if (agePolicy.ageRestrictionPolicyModel != null) {
          let ageRestriction = agePolicy.ageRestrictionPolicyModel;

          if (ageRestriction.ageRestrictionType == AgeRestrictionPolicyTypes.ApplyChargesForSpecificAgeRangeAsARiskFactor) {

            if (ageRestriction.ageChargesList != null) {
              ageRestriction.ageChargesList.forEach(element => {
                if (this.customerAge >= element.ageFrom && this.customerAge <= element.ageTo) {
                  anyFLagOn = true;
                  this.ageResrictionPolicyFlag = true;
                  //Check if age restrection have discount
                  let _freePolicy = this.freePolicies.filter(o => o.policyDefinitionID == agePolicy.policyDefinitionId)[0];
                  //IF Does not have discount then count the price else the price is 0
                  if (_freePolicy == null) {
                    this.ageRestrectionCharge = element.chargePercentage;
                  }
                  else {
                    this.ageRestrectionCharge = 0;
                  }

                }
                else {
                  //this.ageResrictionPolicyFlag = false;
                  //this.ageRestrectionCharge = 0;
                }
              });
              if (this.ageResrictionPolicyFlag && !anyFLagOn) {
                this.ageResrictionPolicyFlag = false;
              }
            }
          }
        }



      }
    }

  }





}
